var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_526",
    "data-name": "Grupo 526",
    transform: "translate(-208 -639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_338",
    "data-name": "Rect\\xE1ngulo 338",
    width: 26,
    height: 26,
    transform: "translate(208 639)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "feed_FILL0_wght300_GRAD0_opsz40",
    d: "M141.841-800a1.772,1.772,0,0,1-1.3-.541,1.772,1.772,0,0,1-.541-1.3v-16.32a1.772,1.772,0,0,1,.541-1.3,1.772,1.772,0,0,1,1.3-.541h11.88a1.8,1.8,0,0,1,.723.149,1.882,1.882,0,0,1,.59.4l4.422,4.422a1.884,1.884,0,0,1,.4.59,1.8,1.8,0,0,1,.149.723v11.88a1.772,1.772,0,0,1-.541,1.3,1.772,1.772,0,0,1-1.3.541Zm0-1.478h16.32a.353.353,0,0,0,.26-.1.353.353,0,0,0,.1-.26V-813.66h-3.941a.892.892,0,0,1-.657-.263.892.892,0,0,1-.263-.657v-3.941H141.841a.352.352,0,0,0-.26.1.352.352,0,0,0-.1.26v16.32a.353.353,0,0,0,.1.26A.353.353,0,0,0,141.841-801.477Zm13.021-3.383a.714.714,0,0,0,.527-.213.721.721,0,0,0,.212-.529.708.708,0,0,0-.212-.526.72.72,0,0,0-.527-.21H145.14a.714.714,0,0,0-.527.213.721.721,0,0,0-.212.529.709.709,0,0,0,.212.526.72.72,0,0,0,.527.21Zm-5.6-8.8a.714.714,0,0,0,.527-.213A.721.721,0,0,0,150-814.4a.709.709,0,0,0-.212-.526.72.72,0,0,0-.527-.21H145.14a.713.713,0,0,0-.527.213.72.72,0,0,0-.212.529.709.709,0,0,0,.212.526.72.72,0,0,0,.527.21Zm5.6,4.4a.714.714,0,0,0,.527-.213A.721.721,0,0,0,155.6-810a.708.708,0,0,0-.212-.526.72.72,0,0,0-.527-.21H145.14a.713.713,0,0,0-.527.213.72.72,0,0,0-.212.529.709.709,0,0,0,.212.526.72.72,0,0,0,.527.21Zm-13.383-9.261v0Z",
    transform: "translate(70.999 1462.041)",
    fill: "#e7e7e7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.b61c9198cc6c5aedc4279ddbaf6ddbd6.svg";
export { ForwardRef as ReactComponent };